<template>
  <button class="button" :class="classes">
    <div class="button__icon">
    <component :is="image" /> 
    </div>
    <slot />
  </button>
</template>

<script>

import { defineAsyncComponent } from 'vue';
import InformationIcon from '@/components/icons/InformationIcon.vue';
import ArrowRight from '@/components/icons/ArrowRight.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';

export default {
  components: {
    InformationIcon,
    ArrowRight,
    DownloadIcon
  },
  props: {
    icon: {
      type: String,
      required: false,
      defualt: false
    },
    border: {
      type: Boolean,
      required: false,
      default: false
    },
    target: {
      type: String,
      required: false,
      default: '_self',
      validator: value => ['_self', '_blank', '_parent', '_top']
    },
    size: {
      type: String,
      required: false,
      default: 'md',
      validator: value => ['sm', 'md', 'lg'].includes(value)
    },
    theme: {
      type: String,
      required: false,
      default: 'primary',
      validator: value => ['primary', 'white', 'dark'].includes(value)
    },
  },
  computed: {
    image() {
      let name = 'InformationIcon';
      if (this.icon === 'ArrowRight') {
        name = 'ArrowRight';
      } else if (this.icon === 'DownloadIcon') {
        name = 'DownloadIcon';
      }
      return name;
    },
    classes() {
      let classes = [`button--${this.size}`, `button--${this.theme}`];
      if (this.border) {
        classes.push('button--border');
      }
      return classes;
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  @include font('open-sans', 'semibold');
  display: inline-flex;
  line-height: 1.4;
  text-align: left;
  transition: background-color 0.2s, color 0.2s;
  &--border {
    border: 2px solid transparent;
    padding: spacing('md') spacing('md', 1.5);
    &.button--primary {
      border-color: color('primary');
      color: color('black');
      &:hover {
        background-color: color('primary');
        color: color('white');
      }
    }
    &.button--white {
      border-color: color('white');
      color: color('white');
      &:hover {
        background-color: color('white');
        color: color('black');
      }
    }
    &.button--dark {
      border-color: color('dark');
      color: color('dark');
      &:hover {
        color: color('dark');
      }
    }
  }
  &--sm {
    @include font-size('paragraph', 'sm');
  }
  &--md {
    @include font-size('paragraph', 'md');
  }
  &--lg {
    @include font-size('paragraph', 'lg');
  }
  &--primary {
    color: color('black');
  }
  &--white {
    color: color('white');
  }
  &__icon {
    align-items: center;
    display: none;
    margin-right: spacing('md');
    :deep(svg) {
      display: block;
    }
    .button--primary & {
      color: color('primary');
      transition: color 0.2s;
    }
    .button--primary.button--border:hover & {
      color: color('white');
    }
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
